/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import NotificationItem from 'components/molecules/notification_item';
import { getConsumer } from 'services/cable';
import { ApplicationState } from 'store';
import {
  NewNotificationState,
  NotificationTypes,
  NotificationRequestTypes,
} from 'store/modules/new_notification_store/types';
import { ProfileState } from 'store/modules/profile_store/types';
import LockedOverlay from 'components/atoms/locked_overlay';
import useOnlyConlicitaseg from 'hooks/useOnlyConlicitaseg';
import { isConlicitasegAllowedRoute } from 'services/conlicitaseg_only_routes';
import * as S from './styles';

const ALL_NOTIFICATIONS_ROUTE = '/notification/notifications';

interface NotificationsMenuProps {
  callback: () => void;
  isNotificationsOpen: boolean;
  setIsNotificationsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const NotificationsMenuNew = ({
  callback,
  isNotificationsOpen,
  setIsNotificationsOpen,
}: NotificationsMenuProps) => {
  const dispatch = useDispatch();

  const cableApp = getConsumer();

  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  const { notifications } = useSelector<ApplicationState, NewNotificationState>(
    (state) => state.session.new_notification,
  );
  const isOnlyConlicitaseg = useOnlyConlicitaseg();
  const isAllNotificationsLocked =
    isOnlyConlicitaseg && !isConlicitasegAllowedRoute(ALL_NOTIFICATIONS_ROUTE);

  const [channel, setChannel] = useState<any>(null);

  const unreadCount = useMemo(() => {
    return notifications.filter((notification: NotificationTypes) => notification.read !== true)
      .length;
  }, [notifications]);

  const notificationItems = useMemo(() => {
    const unreadNotifications = notifications.filter(
      (notification: NotificationTypes) => notification.read !== true,
    );

    if (unreadNotifications.length === 0) {
      return (
        <li className="text-center">
          <label>Nenhuma nova notificação.</label>
        </li>
      );
    }

    return unreadNotifications.slice(0, 10).map((notification) => (
      <React.Fragment key={notification.id}>
        <NotificationItem
          notification={notification}
          classType="dropdown-item"
          key={`campaing_notification_menu_item_${notification.id}`}
        />
        <div className="dropdown-divider" />
      </React.Fragment>
    ));
  }, [notifications]);

  useEffect(() => {
    if (channel) return;

    const subscription = cableApp.subscriptions.create(
      { channel: 'NotificationsChannel', user_id: profile.id },
      {
        received: (message: NotificationTypes) => {
          dispatch({
            type: NotificationRequestTypes.ADD_SINGLE_NOTIFICATION,
            result: message,
          });
        },
      },
    );

    setChannel(subscription);
  }, [channel, dispatch, profile.id]);

  return (
    <S.Container className="fragment">
      <a
        className={`nav-link ${profile.representant ? 'text-white' : 'notification-bell'}`}
        href="#"
        role="button"
        onClick={() => {
          setIsNotificationsOpen(!isNotificationsOpen);
          callback();
        }}
      >
        <span
          className={`material-icons ${unreadCount > 0 ? 'notification-badge' : ''}`}
          title="Notificações"
          aria-hidden="true"
          data-notification-badge={unreadCount || ''}
        >
          notifications
        </span>
      </a>

      <div className={`dropdown-menu dropdown-menu-right ${isNotificationsOpen && 'show'}`}>
        {notificationItems}

        {isAllNotificationsLocked ? (
          <LockedOverlay variant="inline" className="d-block">
            <span className="dropdown-item text-center all-notifications">Todas notificações</span>
          </LockedOverlay>
        ) : (
          <a className="dropdown-item text-center all-notifications" href={ALL_NOTIFICATIONS_ROUTE}>
            Todas notificações
          </a>
        )}
      </div>
    </S.Container>
  );
};

export default NotificationsMenuNew;
